export { SliderView } from "./SliderView";
